/* NasoStrips · Envío protegido — lógica compartida (ficha, carrito lateral y página del carrito).
   Reglas: nunca se añade sin que el cliente marque la casilla, como máximo 1 unidad,
   y nunca se queda sola en el carrito si el cliente quita los packs. */
(() => {
  const P = window.NSProtect;
  if (!P || window.NSProtectAPI) return;
  const root = window.Shopify?.routes?.root || '/';

  const request = async (path, body) => {
    const options = body
      ? {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)}
      : {credentials: 'same-origin', headers: {Accept: 'application/json'}};
    const response = await fetch(root + path, options);
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'No hemos podido actualizar tu pedido.');
    return data;
  };
  const lineOf = cart => cart.items.find(item => item.variant_id === P.variantId);
  const othersOf = cart => cart.items.reduce((total, item) => total + (item.variant_id === P.variantId ? 0 : item.quantity), 0);

  /* Deja el carrito con la protección puesta (1 ud.) o quitada. Devuelve el carrito final. */
  const set = async on => {
    let cart = await request('cart.js');
    const line = lineOf(cart);
    if (on && !othersOf(cart)) on = false;
    if (on && !line) {
      await request('cart/add.js', {items: [{id: P.variantId, quantity: 1}]});
      cart = await request('cart.js');
    } else if (line && (!on || line.quantity !== 1)) {
      await request('cart/change.js', {id: line.key, quantity: on ? 1 : 0});
      cart = await request('cart.js');
    }
    return cart;
  };

  /* Ficha («Comprar ahora»): añade el pack y deja la protección como la haya marcado el cliente.
     Si la protección fallara, el pack se compra igual: nunca bloquea una venta. */
  const buy = async (packItem, wanted) => {
    const cart = await request('cart.js').catch(() => null);
    const line = cart ? lineOf(cart) : null;
    const withProtect = wanted && !line;
    const add = items => fetch(root + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
    let response = await add(withProtect ? [{id: P.variantId, quantity: 1}, packItem] : [packItem]);
    if (!response.ok && withProtect) response = await add([packItem]);
    if (response.ok && line && (!wanted || line.quantity !== 1)) {
      await request('cart/change.js', {id: line.key, quantity: wanted ? 1 : 0});
    }
    /* A pleno pulmón: si toca regalo, se añade antes de ir al pago. Nunca bloquea la compra. */
    if (response.ok && window.NSClubAPI) await window.NSClubAPI.sync().catch(() => {});
    return response;
  };

  const syncCard = card => {
    const input = card.querySelector('[data-ns-protect-input]');
    if (input) card.classList.toggle('is-on', input.checked);
  };

  window.NSProtectAPI = {request, set, buy, lineOf, othersOf, syncCard};

  document.addEventListener('change', async event => {
    const input = event.target.closest?.('[data-ns-protect-input]');
    if (!input) return;
    const card = input.closest('[data-ns-protect-card]');
    syncCard(card);
    if (card.dataset.context !== 'cart') return;
    const error = card.querySelector('[data-ns-protect-error]');
    card.setAttribute('aria-busy', 'true');
    if (error) error.textContent = '';
    try {
      await set(input.checked);
      window.location.reload();
    } catch (e) {
      input.checked = !input.checked;
      syncCard(card);
      card.removeAttribute('aria-busy');
      if (error) error.textContent = e.message;
    }
  });

  /* Limpieza: si alguien vacía el carrito y solo queda la protección, se quita sola. */
  if (P.inCart > 0 && P.others === 0) {
    set(false).then(() => {
      if (document.getElementById('ns-premium-cart')) window.location.reload();
    }).catch(() => {});
  }
})();
